<template>
  <div class="pub-home">
    <div class="main">
      <div class="main-header">
        <h3>{{ notice.title }}</h3>
      </div>

      <div class="main-body">
        <div v-html="notice.content"></div>
      </div>
      <div class="btns">
        <el-button
          type="primary"
          :loading="loading"
          @click.native.prevent="close"
        >
          确认
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
const defaultNotice = {
  title: "",
  subject: "",
  noticeType: "",
  sendTime: "",
  status: 1,
  content: "",
};

export default {
  name: "Pub",
  props: {
    notice: defaultNotice,
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.pub-home {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  background: #fff;
  position: relative;
  width: 800px;
  min-height: 40vh;
  max-height: 90vh;
  text-align: center;
  border-radius: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main-header{
  background-color: #fff;
  /* border-bottom: 2px solid #e5e5e5; */
  width: 100%;
  line-height: 1.3;
  font-size: 24px;
  padding: 0 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: left;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
}
.main-body{
  flex: 1;
  overflow-y: auto;
  padding: 0 30px;
  box-sizing: border-box;
  text-align: justify;
  line-height: 1.75;
}
.btns {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  margin-top: auto;
  padding:20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-top-close{
  position: absolute;
  right: 20px;
  background-color: #eee;
  color: #191919;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
}
.right-top-close:hover{
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/PubInfo.vue